import { render, staticRenderFns } from "./UserCourseStatistic.vue?vue&type=template&id=15e1f083&scoped=true&"
import script from "./UserCourseStatistic.vue?vue&type=script&lang=ts&"
export * from "./UserCourseStatistic.vue?vue&type=script&lang=ts&"
import style0 from "./UserCourseStatistic.vue?vue&type=style&index=0&id=15e1f083&lang=scss&scoped=true&"
import style1 from "./UserCourseStatistic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e1f083",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VTextField})
